export default "__VITE_ASSET__9256de8b__"